"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PhoneSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.4803746,9.18438628 L14.6022902,10.5332243 C14.977582,10.771786 15.1502479,11.2295144 15.0260189,11.6565072 L14.3125072,14.1087871 C14.1795558,14.5657598 13.742955,14.8657096 13.2687033,14.8258925 C10.8578892,14.6234859 8.65581854,13.5254458 6.66249127,11.5317722 C4.65993818,9.52887119 3.56101433,7.31560409 3.36571972,4.89197087 C3.32871306,4.43321962 3.60962491,4.00847117 4.0462483,3.86293004 L6.47464956,3.05346296 C6.93443478,2.90020122 7.43793645,3.098705 7.66943015,3.52450105 L8.86913699,5.73117208 C9.10844983,6.17135019 8.98507787,6.72068611 8.58052642,7.01626272 L7.72315144,7.64268489 L10.5515786,10.471112 L11.0707092,9.54096273 C11.3398652,9.058704 12,8.85870361 12.4803746,9.18438628 Z M6.71251168,4.00692711 L4.34281736,4.81816624 C4.44520316,6.90327004 5.44623897,8.90130632 7.36959805,10.8246654 C9.29295713,12.7480245 11.2909934,13.7490603 13.3760972,13.8514461 L14.012739,11.4424153 L12.0443688,10.134168 L11.4789324,11.0755721 C11.1945646,11.5490206 10.458651,11.7982744 9.90630931,11.2594257 L7.01685213,8.30123378 C6.63094482,7.90614646 6.60990195,7.19706527 7.11433354,6.81622025 L7.94974747,6.15971031 L6.71251168,4.00692711 Z" })));
};
PhoneSmall.displayName = 'PhoneSmall';
exports.default = PhoneSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PhoneSmall.js.map